import type { CSSProperties, FC, ReactNode } from 'react'

import useDimensions from '../../hooks/useDimensions'
import DesktopLayout from './desktop-layout'
import MobileLayout from './mobile-layout'

interface LayoutProps {
  hideScrollUp?: boolean
  hideChat?: boolean
  hideInbox?: boolean
  style?: CSSProperties
  hideBalance?: boolean
  children: ReactNode
}

const Layout: FC<LayoutProps> = ({ children, ...rest }) => {
  const { isDesktop } = useDimensions()

  if (isDesktop) return <DesktopLayout {...rest}>{children}</DesktopLayout>

  return <MobileLayout {...rest}>{children}</MobileLayout>
}

export default Layout
